import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    visibilityDate: {
      title: 'Dzień przypomnienia',
      type: 'string',
      fieldRequired: true,
      format: 'Date'
    },
    receiverId: {
      type: 'number',
      fieldRequired: true
    },
    entityId: {
      type: 'string',
      fieldRequired: true
    },
    entityType: {
      type: 'string',
      fieldRequired: true
    },
    name: {
      title: 'Nazwa powiadomienia',
      type: 'string',
      fieldRequired: true
    },
    body: {
      title: 'Treść',
      type: 'string',
      fieldRequired: true
    }
  },
  allOf: [validationMessages]
};
